import React from 'react';
import { WebBasic } from 'ui';

const WebBasicPage = (): JSX.Element => {
  return <WebBasic />;
};

export default WebBasicPage;
